import { useContext, useState } from "react";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import { endOfDay, endOfMonth, format, startOfMonth } from "date-fns";
import UiContext from "../../../../store/ui-context";

const now = new Date();

export const useAPIGetDashboard = () => {
  const uiContext = useContext(UiContext);
  const { requestGetOne, requestGet, loading } = useAPIRequest();
  const [generalData, setGeneralData] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [employeeData, setEmployeeData] = useState(null);
  const [error, setError] = useState({});

  const [filterValue, setFilterValue] = useState({
    // dari_tanggal: format(new Date(), "yyyy-MM-dd"),
    // sampai_tanggal: format(new Date(), "yyyy-MM-dd"),
    dari_tanggal: format(startOfMonth(new Date()), "yyyy-MM-dd HH:mm:ss"),
    sampai_tanggal: format(endOfMonth(new Date()), "yyyy-MM-dd HH:mm:ss"),
  });

  const fetchGeneralData = async ({ filter }) => {
    if (!validate()) {
      return;
    }
    const newFilter = filter ?? getFilter(filterValue);

    return requestGet({
      fullUrl: `/api/report`,
      params: {
        take: 10000000,
        prefix: "dashboard_general",
        filter: newFilter,
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        setGeneralData(_data);
      },
    });
  };

  const fetchEmployeeData = async ({ filter }) => {
    if (!validate()) {
      return;
    }
    const newFilter = filter ?? getFilter(filterValue);

    return requestGet({
      fullUrl: `/api/report`,
      params: {
        take: 10000000,
        prefix: "dashboard_employee",
        filter: newFilter,
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        setEmployeeData(_data);
      },
    });
  };

  const fetchCustomerData = async ({ filter }) => {
    if (!validate()) {
      return;
    }
    const newFilter = filter ?? getFilter(filterValue);

    return requestGet({
      fullUrl: `/api/report`,
      params: {
        take: 10000000,
        prefix: "dashboard_customer",
        filter: newFilter,
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        setCustomerData(_data);
      },
    });
  };

  const getFilter = (_filterValue) => {
    const filterArr = [];
    const newFilterValue = _filterValue ?? filterValue;
    if (newFilterValue.dari_tanggal) {
      filterArr.push(
        `start_date:=:${newFilterValue.dari_tanggal.split(" ")[0]} 00:00:00`
      );
    }

    if (newFilterValue.sampai_tanggal) {
      filterArr.push(
        `end_date:=:${newFilterValue.sampai_tanggal.split(" ")[0]} 23:59:59`
      );
    }

    return filterArr.join(";");
  };

  const validate = () => {
    let isValid = true;

    const start = new Date(filterValue.dari_tanggal);
    const end = new Date(filterValue.sampai_tanggal);
    setError({});
    if (!filterValue.dari_tanggal) {
      isValid = false;
    }

    if (!filterValue.sampai_tanggal) {
      isValid = false;
    }

    if (start > end) {
      isValid = false;
      setError((prev) => ({
        ...prev,
        tanggal: "Start Date must be before End Date",
      }));
    }
    return isValid;
  };

  return {
    loading,
    error,
    setFilterValue,
    filterValue,
    fetchGeneralData,
    fetchEmployeeData,
    fetchCustomerData,
    generalData,
    setGeneralData,
    employeeData,
    setEmployeeData,
    customerData,
    setCustomerData,
  };
};
